module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "file-upload"
  }, [_c('div', {
    staticClass: "fileup-btn relative"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "upload-tips"
  }, [_vm._v("上传中...")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "upload-tips"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.currentValue) ? _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "src": _vm._f("ossResize")(_vm.currentValue, 'middle')
    }
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "input",
    staticClass: "fileup-input",
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c229e76"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/file-upload/index.vue
// module id = 285
// module chunks = 107